module.exports = __webpack_public_path__ + "media/images/リピート割引_1000円_1280_480-9df05fa30e1a70f4ce716c97f10d3736.png";